import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import Axios from 'axios';
import { errorCatch } from './errorCatcher.reducer';

export type PreviewOrder = {
  setupFee: number;
  subscriptionFee: number;
  connectionFee: number;
  taxes: number;
  startDate: string;
  endDate: string;
};

class PreviewError {
  country: [string] | null;
  region: [string] | null;
  city: [string] | null;
  postalCode: [string] | null;

  constructor(country?: [string], state?: [string], city?: [string], postalCode?: [string]) {
    this.country = country || null;
    this.region = state || null;
    this.city = city || null;
    this.postalCode = postalCode || null;
  }
}

export type InitState = {
  preview: {
    status: string;
    data: PreviewOrder | null;
  };
  previewError: PreviewError | null;
};

export const initialState = {
  preview: {
    status: '',
    data: null
  },
  previewError: null
} as InitState;

export type PreviewOrderRequestType = {
  employees: number;
  country: string;
  countryIso2: string;
  state: string;
  stateId: string;
  city: string;
  postalCode: string;
  sku: string | null;
};

export const previewOrder = createAsyncThunk(
  'order/previewOrder',
  async (previewOrder: PreviewOrderRequestType, { dispatch }) => {
    try {
      const { data } = await Axios.post('/api/v1/billing/order/preview', previewOrder);
      if (data && data.errors) {
        const { country, state, city, postalCode } = data.errors;
        dispatch(slice.actions.savePreviewError(new PreviewError(country, state, city, postalCode)));
        return;
      }
      return data;
    } catch (error) {
      dispatch(errorCatch({ place: 'order/previewOrder.rejected', data: error }));
      return Promise.reject(error);
    }
  }
);

const slice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    savePreviewError: (state, action: PayloadAction<PreviewError>) => {
      state.previewError = action.payload;
    },
    clearPreviewError: state => {
      state.previewError = initialState.previewError;
    }
  },
  extraReducers: {
    // preview
    [previewOrder.pending.toString()]: state => {
      state.preview.status = 'loading';
    },
    [previewOrder.fulfilled.toString()]: (state, action) => {
      state.preview.data = action.payload;
      state.preview.status = 'success';
    },
    [previewOrder.rejected.toString()]: state => {
      state.preview.status = 'rejected';
    }
  }
});

export const { clearPreviewError } = slice.actions;
export default slice.reducer;
